<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<g clip-path="url(#clip0_11035_329)">
		<path
			d="M9.92005 4.76133C9.92005 5.24886 10.3189 5.64775 10.8065 5.64775H13.1023L5.00928 13.7408C4.66357 14.0865 4.66357 14.6449 5.00928 14.9906C5.35498 15.3363 5.91343 15.3363 6.25913 14.9906L14.3522 6.8976V9.19343C14.3522 9.68096 14.751 10.0799 15.2386 10.0799C15.7261 10.0799 16.125 9.68096 16.125 9.19343V3.87488L10.8065 3.87491C10.3189 3.87491 9.92005 4.2738 9.92005 4.76133Z"
			fill="#FEFCF5"
		/>
		<path
			d="M10.0799 15.2384C10.0799 14.7509 9.68106 14.352 9.19353 14.352L6.8977 14.352L14.9907 6.25901C15.3364 5.9133 15.3364 5.35486 14.9907 5.00915C14.645 4.66345 14.0866 4.66345 13.7409 5.00915L5.64784 13.1022L5.64784 10.8063C5.64784 10.3188 5.24895 9.91991 4.76142 9.91991C4.27389 9.91991 3.875 10.3188 3.875 10.8063L3.875 16.1249L9.19353 16.1248C9.68106 16.1248 10.0799 15.726 10.0799 15.2384Z"
			fill="#FEFCF5"
		/>
	</g>
	<defs>
		<clipPath id="clip0_11035_329">
			<rect width="14" height="14" fill="white" transform="translate(3 3)" />
		</clipPath>
	</defs>
</svg>
